import { useQuery } from '@tanstack/react-query';

import { useConfig } from '@/shared/contexts/config';
import { getAdminConsoleUser, getUserConsoleUser } from '@/shared/api/cloud';
import { GetAdminConsoleUserResponse } from '@/shared/api/cloud/types';

const isAdminUser = (data: object): data is GetAdminConsoleUserResponse => {
  return 'user_name' in data;
};

export const useGetUser = () => {
  const { appName } = useConfig();
  const isAdminConsole = appName === 'adminconsole';

  return useQuery({
    queryKey: ['getUser'],
    queryFn: async () => {
      const { data } = isAdminConsole
        ? await getAdminConsoleUser()
        : await getUserConsoleUser();

      return data;
    },
    select: (data) => {
      if (isAdminUser(data)) {
        return { email: data.user_name };
      }
      return {
        email: data.user.email,
        id: data.user.user_id,
        orgId: data.user.organization_id,
      };
    },
    staleTime: 30 * 60 * 1000,
  });
};
